// frontend/src/components/support/PackageCard.js
export default function PackageCard({ pkg, onSelect }) {
  return (
    <div
      onClick={() => onSelect(pkg)}
      style={{
        background: "rgba(255,255,255,0.05)",

        border: "2px solid rgba(255,255,255,0.08)",

        borderRadius: 20,

        padding: 24,

        cursor: "pointer",

        transition: "0.2s",

        display: "flex",

        flexDirection: "column",

        alignItems: "center",

        textAlign: "center",
      }}
    >
      <img
        src={pkg.icon}
        alt={pkg.name}
        style={{
          width: 96,
          height: 96,

          objectFit: "contain",

          marginBottom: 20,

          imageRendering: "pixelated",

          filter: "drop-shadow(0 0 10px rgba(0,0,0,0.5))",
        }}
      />

      <h2
        style={{
          marginTop: 0,
        }}
      >
        {pkg.name}
      </h2>

      <div
        style={{
          fontSize: 38,

          color: "#ffb100",

          marginBottom: 20,
        }}
      >
        ${pkg.price}
      </div>

      <div
        style={{
          display: "grid",

          gap: 10,

          opacity: 0.9,
        }}
      >
        {pkg.rewards.map((reward) => (
          <div key={reward}>• {reward}</div>
        ))}
      </div>
    </div>
  );
}
